/**
 * Word lists index
 * Exports all word lists with a unified interface
 */

import words5 from './words-5';
import words6 from './words-6';
import words7 from './words-7';
import words8 from './words-8';
import words9 from './words-9';
import words10 from './words-10';

// Type for word lists with numeric keys
export type WordListsType = {
  [key: number]: string[];
  5: string[];
  6: string[];
  7: string[];
  8: string[];
  9: string[];
  10: string[];
};

export const WORD_LISTS: WordListsType = {
  5: words5,
  6: words6,
  7: words7,
  8: words8,
  9: words9,
  10: words10
};

export { words5, words6, words7, words8, words9, words10 };
